import { createContext, useContext } from 'react';

export interface DocsRouteValue {
  role: string;
  pageSlug: string;
}

export const DocsRouteContext = createContext<DocsRouteValue | null>(null);

export function useDocsRoute(): DocsRouteValue {
  const ctx = useContext(DocsRouteContext);
  if (!ctx) throw new Error('useDocsRoute must be used inside a DocsRouteContext.Provider');
  return ctx;
}
